import { render, staticRenderFns } from "./remarks.vue?vue&type=template&id=12f856d0&scoped=true"
import script from "./remarks.vue?vue&type=script&lang=js"
export * from "./remarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f856d0",
  null
  
)

export default component.exports